import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import Creatable from 'react-select/creatable';
import FileUpload from 'components/FileUpload/FileUpload'
import { RichTextField } from 'components/RichText'

function NuevaWiki(props) {
	const { etiquetasExistentes, guardar, setQueMostrar } = props
	const [etiquetas, setEtiquetas] = useState([])

	const datosWikiInicial = {
		nombre: '',
		familia: '',
		descripcion: '',
		usos: '',
		cultivo: '',
		experiencias: '',
		imagen: false,
		fechaCreacion: ''
	}
	const [datosWiki, setDatosWiki] = useState(datosWikiInicial)
	const [erroresValidacion, setErroresValidacion] = useState({})

	const opciones = etiquetasExistentes.map(elem => ({ label: elem.nombre, value: elem.id }))

	const handleClose = () => {
		setQueMostrar('')
		setDatosWiki(datosWikiInicial)
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datosWiki,
			etiquetas: etiquetas.map(elem => elem.label),
			fechaCreacion: new Date()
		}

		if (!data.link) {
			delete data.link
		}

		if (validarDatos()) {
			guardar(data)
			handleClose()
		}
	}

	const validarDatos = () => {
		const camposRequeridos = ['nombre']
		const nuevosErrores = {}

		camposRequeridos.forEach(campo => {
			if (datosWiki[campo].trim() === '') {
				nuevosErrores[campo] = 'Este es un campo requerido'
			} else {
				nuevosErrores[campo] = null
			}
		})

		const errores = { ...erroresValidacion, ...nuevosErrores }

		setErroresValidacion(errores)

		return Object.keys(errores).filter(elem => errores[elem] !== null).length === 0
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datosWiki }
		datosCopia[key] = value
		setDatosWiki(prev => datosCopia)
	}

	const handleSeleccionImagen = (files) => {
		setDatosWiki({ ...datosWiki, imagen: files[0] })
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Nueva entrada" />
			<Offcanvas.Body id="nueva-wiki">
				<h1>Campos de la planta</h1>
				<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="wiki-nombre">
										<FormLabel>Nombre</FormLabel>
										<Form.Control
											value={datosWiki.nombre}
											onChange={(e) => handleChange(e.target.value, 'nombre')}
											isInvalid={erroresValidacion.nombre}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.nombre}</Form.Control.Feedback>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="wiki-familia">
										<FormLabel>Familia</FormLabel>
										<Form.Control
											value={datosWiki.familia}
											onChange={(e) => handleChange(e.target.value, 'familia')}
											isInvalid={erroresValidacion.familia}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.familia}</Form.Control.Feedback>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="wiki-etiquetas">
										<FormLabel>Etiquetas</FormLabel>
										<Creatable
											onChange={setEtiquetas}
											options={opciones}
											isMulti={true}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="wiki-descripcion">
										<RichTextField
											value={datosWiki.descripcion}
											onChange={(descripcion) => handleChange(descripcion, 'descripcion')}
											label="Descripción"
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="wiki-usos">
										<RichTextField
											value={datosWiki.usos}
											onChange={(usos) => handleChange(usos, 'usos')}
											label="Usos"
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="wiki-cultivo">
										<RichTextField
											value={datosWiki.cultivo}
											onChange={(cultivo) => handleChange(cultivo, 'cultivo')}
											label="Cultivo"
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="wiki-experiencias">
										<RichTextField
											value={datosWiki.experiencias}
											onChange={(experiencias) => handleChange(experiencias, 'experiencias')}
											label="Experiencias"
										/>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Col>
					<Col sm={12} md={6}>
						<FileUpload
							title="Imagen"
							accept=".png, .jpg, .jpeg"
							buttonText="Elegir"
							buttonTextSingular="imagen"
							updateFiles={handleSeleccionImagen}
						/>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default NuevaWiki